export const LIQUIDACION_REPORTES_RESUMEN_BASE_URL =
  process.env.VUE_APP_LIQUIDACION_REPORTES_RESUMEN_BASE ||
  process.env.VUE_APP_LIQUIDACION_REPORTES_BASE ||
  process.env.VUE_APP_REPORT_VTEX_BASE;

export const LIQUIDACION_REPORTES_DETALLADO_BASE_URL =
  process.env.VUE_APP_LIQUIDACION_REPORTES_DETALLADO_BASE ||
  process.env.VUE_APP_LIQUIDACION_REPORTES_BASE ||
  process.env.VUE_APP_REPORT_VTEX_BASE;

/** UI resumen → report_lq_resumen (data: T[]). */
export const LIQUIDACION_REPORTES_RESUMEN_PATH =
  "/hp/service-system/v1/os-report/report_lq_resumen";

export const LIQUIDACION_REPORTES_RESUMEN_EXPORT_PATH =
  "/hp/service-system/v1/os-report/report_lq_resumen/export";

/** UI detallado → report_lq_detallado (data: { datos: T[], totalRegistros }). */
export const LIQUIDACION_REPORTES_DETALLADO_PATH =
  "/hp/service-system/v1/os-report/report_lq_detallado";

export const LIQUIDACION_REPORTES_DETALLADO_EXPORT_PATH =
  "/hp/service-system/v1/os-report/report_lq_detallado/export";

export const LIQUIDACION_REPORTES_REQUEST_TIMEOUT = 30000;

export const LIQUIDACION_REPORTES_DEFAULT_PERIODO = Number(
  process.env.VUE_APP_LIQUIDACION_REPORTES_DEFAULT_PERIODO || 13,
);

/** 0 = Tienda (gestor), 1 = Proveedor */
export const LIQUIDACION_REPORTES_TIPO_TIENDA = 0;

export const LIQUIDACION_REPORTES_TIPO_PROVEEDOR = 1;

export const RESUMEN_DEFAULT_PER_PAGE = 10;

export const RESUMEN_TH_PENALIDAD = "liquidacion-reportes-th-penalidad";

export const LIQUIDACION_ESTADOS_EXCLUDED_FROM_FILTER = ["BORRADOR"];

export const RESUMEN_MONEY_COLUMNS = [
  "costoSinIgv",
  "costoConIgv",
  "penalidad",
  "totalPorFactSinIgv",
  "igv",
  "totalPorFactConIgv",
];

export const DETALLADO_MONEY_COLUMNS = [
  "costoUnitarioSinIgv",
  "costoUnitarioConIgv",
  "costoTotalSinIgv",
  "costoTotalConIgv",
  "penalidad",
  "costoFinalSinIgv",
  "costoFinalConIgv",
];

export const MESSAGES = {
  RESUMEN_PAGE_TITLE: "Reporte Liquidacion Resumen",
  DETALLADO_PAGE_TITLE: "Reporte Liquidacion Detallado",
  RESUMEN_SECTION_TITLE: "Resultados",
  DETALLADO_SECTION_TITLE: "Resultados",
  EMPTY_TABLE: "No hay registros para mostrar",
  LOADING: "Cargando...",
  LOAD_TIMEOUT_ERROR:
    "No se pudo cargar el reporte. Verifique su conexión e intente nuevamente.",
  LOAD_ERROR: "Ocurrió un error al cargar el reporte.",
  FILTERS_TITLE: "Filtros",
  FILTER_TIENDA_LABEL: "Tienda",
  FILTER_PROVEEDOR_LABEL: "Proveedor",
  FILTER_CORTE_LABEL: "Corte de liquidación",
  FILTER_PERIODO_LABEL: "Periodo de liquidación",
  FILTER_ESTADO_LABEL: "Estado",
  CLEAR_BUTTON: "Limpiar",
  EXPORT_BUTTON: "EXPORTAR",
  EXPORT_NOT_IMPLEMENTED: "Función no implementada.",
  EXPORT_SUCCESS: "Reporte exportado exitosamente",
  EXPORT_ERROR: "Error al exportar el reporte",
};

export function getDefaultPeriodoFilterOptions() {
  return [{ value: 0, text: "Todos" }];
}

export function getDefaultEstadoFilterOptions() {
  return [{ value: 0, text: "Todos" }];
}

/** @deprecated usar getLiquidacionEstados() desde service-catalog */
export function getFiltroEstadoOptions() {
  return getDefaultEstadoFilterOptions();
}

export function getDefaultProveedorFilterOptions() {
  return [{ value: 0, text: "Todos" }];
}

/** @deprecated usar getProviders() desde service-catalog */
export function getFiltroProveedorOptions() {
  return getDefaultProveedorFilterOptions();
}

export function getDefaultFiltroLiquidacion() {
  return {
    idPeriodo: 0,
    idTienda: 0,
    idProv: 0,
    estado: 0,
  };
}

/**
 * Filtros visibles por tipo de reporte y perfil.
 * - Gestor detallado: corte, estado, proveedor, tienda
 * - Gestor resumen: tienda, corte, estado
 * - Proveedor detallado: periodo, estado, tienda
 * - Proveedor resumen: periodo, estado
 */
export function getReportFilterSlots(reportType, isProveedorProfile) {
  if (isProveedorProfile) {
    if (reportType === "detallado") {
      return ["periodo", "estado", "tienda"];
    }

    return ["periodo", "estado"];
  }

  if (reportType === "detallado") {
    return ["periodo", "estado", "proveedor", "tienda"];
  }

  return ["tienda", "periodo", "estado"];
}

export function filterLiquidacionEstadoSelectOptions(options = []) {
  const excluded = new Set(
    LIQUIDACION_ESTADOS_EXCLUDED_FROM_FILTER.map((value) => value.toUpperCase()),
  );

  return options.filter((option) => {
    if (option.value === 0) return true;

    const label = String(option.text ?? "").trim().toUpperCase();
    return !excluded.has(label) && ![...excluded].some((code) => label.includes(code));
  });
}

export function getResumenTableFields(isProveedorProfile = false) {
  const fields = [
    {
      key: "codigoTienda",
      label: "Cód. Tienda",
      thClass: "text-center",
      tdClass: "text-center",
    },
    { key: "tienda", label: "Tienda", thClass: "text-center", tdClass: "text-left" },
    { key: "usuario", label: "Usuario", thClass: "text-center", tdClass: "text-left" },
    { key: "proveedor", label: "Proveedor", thClass: "text-center", tdClass: "text-left" },
    {
      key: "corteLiquidacion",
      label: "Corte de Liquidación",
      thClass: "text-center",
      tdClass: "text-center",
    },
   
    {
      key: "costoSinIgv",
      label: "Costo Total (SIN IGV)",
      thClass: "text-center",
      tdClass: "text-right",
    },
    {
      key: "costoConIgv",
      label: "Costo Total (CON IGV)",
      thClass: "text-center",
      tdClass: "text-right",
    },
    {
      key: "penalidad",
      label: "Penalidad",
      thClass: `text-center ${RESUMEN_TH_PENALIDAD}`,
      tdClass: "text-right",
    },
    {
      key: "totalPorFactSinIgv",
      label: "Tot. por facturar (SIN IGV)",
      thClass: "text-center",
      tdClass: "text-right",
    },
    { key: "igv", label: "IGV", thClass: "text-center", tdClass: "text-right" },
    {
      key: "totalPorFactConIgv",
      label: "Tot. por facturar (CON IGV)",
      thClass: "text-center",
      tdClass: "text-right",
    },
     {
      key: "numeroOc",
      label: "Número OC",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      key: "migo",
      label: "Migo",
      thClass: "text-center",
      tdClass: "text-center",
    },
    {
      key: "archivoPdf",
      label: "PDF",
      thClass: "text-center",
      tdClass: "text-center",
    }
  ];

  if (isProveedorProfile) {
    return fields.filter(
      (field) =>
        !["corteLiquidacion", "usuario", "proveedor"].includes(field.key),
    );
  }

  return fields;
}

/** @deprecated usar getDefaultFiltroLiquidacion */
export function getDefaultResumenFilters() {
  return getDefaultFiltroLiquidacion();
}

/** @deprecated usar getDefaultFiltroLiquidacion */
export function getDefaultDetalladoFilters() {
  return getDefaultFiltroLiquidacion();
}

export function getDetalladoTableFields(isProveedorProfile = false) {
  const fields = [
    { key: "usuario", label: "Usuario", thClass: "text-center", tdClass: "text-left" },
    { key: "proveedor", label: "Proveedor", thClass: "text-center", tdClass: "text-left" },
   // { key: "corteLiquidacion", label: "Corte de Liquidación", thClass: "text-center" },
    { key: "nroOs", label: "Nro. Os", thClass: "text-center" },
    { key: "estado", label: "Estado", thClass: "text-center" },
    { key: "cliente", label: "Cliente", thClass: "text-center" },
    { key: "skuServ", label: "Sku Serv.", thClass: "text-center" },
    { key: "servicio", label: "Servicio", thClass: "text-center" },
    { key: "skuProd", label: "Sku Prod.", thClass: "text-center" },
    { key: "producto", label: "Producto", thClass: "text-center" },
    { key: "cantidad", label: "Cant.", thClass: "text-center", tdClass: "text-right" },
    { key: "fechaServicio", label: "Fec. Servicio", thClass: "text-center" },
    { key: "costoUnitarioSinIgv", label: "C. Uni. Sin Igv", thClass: "text-center", tdClass: "text-right" },
    { key: "costoUnitarioConIgv", label: "C. Uni Con Igv", thClass: "text-center", tdClass: "text-right" },
    { key: "costoTotalSinIgv", label: "C. Tot. Sin Igv", thClass: "text-center", tdClass: "text-right" },
    { key: "costoTotalConIgv", label: "C. Tot Con Igv", thClass: "text-center", tdClass: "text-right" },
    {
      key: "penalidad",
      label: "Penalidad",
      thClass: `text-center ${RESUMEN_TH_PENALIDAD}`,
      tdClass: "text-right",
    },
    { key: "costoFinalSinIgv", label: "C. Final sin IGV", thClass: "text-center", tdClass: "text-right" },
    { key: "costoFinalConIgv", label: "C. Final con IGV", thClass: "text-center", tdClass: "text-right" },
  ];

  if (isProveedorProfile) {
    return fields.filter(
      (field) => !["cliente", "usuario", "proveedor"].includes(field.key),
    );
  }

  return fields;
}
